import { render, staticRenderFns } from "./page-button.vue?vue&type=template&id=a3e5b67a&scoped=true&"
import script from "./page-button.vue?vue&type=script&lang=js&"
export * from "./page-button.vue?vue&type=script&lang=js&"
import style0 from "./page-button.vue?vue&type=style&index=0&id=a3e5b67a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e5b67a",
  null
  
)

export default component.exports